export default "/assets/modules/images/Recommendation-Education.svg?3959eb9f54c364cf9e0dd89b2363f87c";